import type { Group } from "types";
import { useState } from "react";

import { IconButton } from "components/icon-button";
import { Tooltip } from "components/tooltip";
import ArrowIcon from "assets/arrow-left.svg?react";
import FileIcon from "assets/file-check.svg?react";

import styles from "./index.module.css";

export const CallProgress = ({
  groups,
  activeGroupId,
  handleSelectGroup,
}: {
  groups: Group[];
  activeGroupId?: number;
  handleSelectGroup: (groupId: number) => void;
}) => {
  const [open, setOpen] = useState(false);
  const [showCompliance, setShowCompliance] = useState(false);

  const activeGroup = activeGroupId
    ? groups.find((group) => group.id === activeGroupId)
    : groups[0];

  return (
    <div className={styles.container} data-open={open}>
      <div className={styles.toggleContainer} data-open={open}>
        <IconButton onClick={() => setOpen((open) => !open)}>
          <ArrowIcon />
        </IconButton>
      </div>
      <div className={styles.complianceContainer} data-open={open}>
        <Tooltip content="Toggle compliance groups">
          <IconButton
            variant={showCompliance ? "orange" : "transparent-grey"}
            onClick={() => setShowCompliance((showCompliance) => !showCompliance)}
          >
            <FileIcon />
          </IconButton>
        </Tooltip>
      </div>
      <ul className={styles.groupList}>
        {groups.map((groupItem, index) => {
          const isCurrent = groupItem.id === activeGroup?.id;
          const isCompleted =
            isCurrent || index < groups.findIndex((g) => g.id === activeGroup?.id);

          return (
            <button
              onClick={() => handleSelectGroup(groupItem.id)}
              type="button"
              key={groupItem.id}
              className={styles.groupItem}
            >
              <Tooltip content={groupItem.name}>
                <li
                  aria-current={isCompleted}
                  className={styles.group}
                  data-active={isCurrent}
                  data-compliance={showCompliance ? groupItem.isCompliance : null}
                ></li>
              </Tooltip>
              <div
                className={styles.groupItemContent}
                data-active={isCurrent}
                data-compliance={showCompliance && groupItem.isCompliance}
              >
                {groupItem.name}
              </div>
            </button>
          );
        })}
      </ul>
    </div>
  );
};
